import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { TextValidator } from 'react-material-ui-form-validator';
import Typography from "@material-ui/core/Typography";

import useGroupSetting from "Hooks/useGroupSetting";
import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  input: {
    marginLeft: 5,
    marginRight: 5,
  },
}));

export default function Threshold({ state, onChangeThold, onChangeInterval }) {
  const groupSetting = useGroupSetting();
  const classes = useStyles();
  const messages = message();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">条件</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <Typography value="span">前回のメール送信から</Typography>
            <TextValidator
              name="thold"
              onChange={onChangeThold}
              type="number"
              value={ state.alert_params && state.alert_params.thold ? 
                state.alert_params.thold : 
                groupSetting.setData("thold", 20) }
              style={{ width: 185 }}
              InputProps={{ inputProps: { min: 1}, className: classes.input }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "件")).replace("$2", "1")
              ]}
            />
            <Typography value="span">件以上の場合に通知する</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">通知制限</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <Typography value="span">前回のメール送信から</Typography>
            <TextValidator
              name="interval"
              onChange={onChangeInterval}
              type="number"
              value={ state.alert_params && state.alert_params.interval ? 
                state.alert_params.interval : 
                groupSetting.setData("interval", 60) }
              style={{ width: 185 }}
              InputProps={{ inputProps: { min: 1}, className: classes.input }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "分")).replace("$2", "1")
              ]}
            />
            <Typography value="span">
              分経過するまでメールを送信しない
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
